(function () {

  var counters = document.querySelectorAll('.value');
  var speed = 200;

  function counter() {
    counters.forEach(counter => {
      var animate = () => {
        var value = +counter.getAttribute('number');
        var data = +counter.innerText;

        var time = value / speed;
        if (data < value) {
          counter.innerText = Math.ceil(data + time);
          setTimeout(animate, 1);
        } else {
          counter.innerText = value + '%';
        }
      };
      animate();
    });
  }

  function observe() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
        //console.log('Found it!');
        counter();
        }
      });
    });
    observer.observe(document.querySelector('.wp-block-acf-count-numbers'));
  }

  if (document.querySelector('.wp-block-acf-count-numbers')) {
    observe();
  } else {
    //console.log('Not found!');
    return;
  }

}());
